import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { memo } from "react";

const DatatypeSelector = memo(({ elementXName, allowedDatatypes, datatypeState, setDatatypeState }) => {
    return <div>
      <p style={{ marginBottom: "0px" }}><b>{elementXName} Datatype:</b></p>
      <FormControl>
        <FormLabel id="radiodatatypeselector-label" style={{ color: "#000000", paddingBottom: "6px" }}>Choose one way to define this value: <i>(If you Update with a different datatype, you will lose previous {elementXName} data.)</i></FormLabel>
        <RadioGroup aria-label="radiodatatypeselector" name={"radiodatatypeselector-" + elementXName}
          value={datatypeState} onChange={(e) => { setDatatypeState(e.target.value); }}>
          {allowedDatatypes.map((allowedDatatype, allowedDatatypeIndex) => {
            return <FormControlLabel
              key={allowedDatatypeIndex}
              value={allowedDatatype}
              control={<Radio color="primary" style={{ paddingTop: "4px", paddingBottom: "4px" }} />}
              name="radio-button-control"
              color="default"
              inputprops={{ 'aria-label': allowedDatatype }}
              label={<span style={{ textAlign: 'center' }}><b>{allowedDatatype}</b></span>}
              style={{ paddingLeft: "12px" }}
            />
          })}
        </RadioGroup>
      </FormControl></div>
  });

  export default DatatypeSelector;